import { ChangeEvent } from "react";
import InputElementTopSection from "../components/input-element-top-section/input-element-top-section";
import styles from "./text-area.module.less";

export type TTextAreaProps = {
  label?: string;
  helperText?: string;
  errorText?: string;

  name: string;
  placeholder?: string;
  value?: string;
  isValid?: boolean;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  maxLength?: number;
  minLength?: number;
  onChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
};

export const TextArea = ({
  label,
  helperText,
  errorText,
  name,
  placeholder,
  value,
  isValid,
  isDisabled,
  isReadOnly,
  maxLength = 120,
  minLength = undefined,
  onChange,
}: TTextAreaProps) => {
  const hasError = isValid === false;

  return (
    <div className={`${styles.wrapper} space-mb-md`}>
      <InputElementTopSection
        label={label}
        helperText={helperText}
        errorText={hasError && errorText ? errorText : undefined}
        htmlFor={name}
      />
      <textarea
        disabled={isDisabled}
        readOnly={isReadOnly}
        className={[styles.textArea, "font-family-preem-sans-new", hasError ? styles.error : ""].join(" ")}
        id={name}
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e)}
        minLength={minLength}
        maxLength={maxLength}
      />
      <div className={styles.counterWrapper}>
        <span className={[styles.characterCounter, "body-s mb-0"].join(" ")}>
          {value?.length ?? 0} / {maxLength}
        </span>
      </div>
    </div>
  );
};

export default TextArea;
